import React from 'react'
import _ from 'lodash'
import { ActionButton, Cell, Table, TD, ActionWrapper, ActionButtonsWrapper } from './styled'
/**
 * Component which renders a single column loader for the grid
 * @author Alejandro Quiroz <alejandro.devop@gmail.com>
 * @version 1.0.0
 * @param param0
 * @returns
 */
const RenderCell: React.FC<{ delay: number; children?: React.ReactNode }> = ({ delay }) => (
    <TD>
        <Cell delay={delay} />
    </TD>
)

/**
 * Component which renders a whole row for the table loader
 * @author Alejandro Quiroz <alejandro.devop@gmail.com>
 * @version 1.0.0
 * @param param0
 * @returns
 */
const RenderRow: React.FC<{ columns: number; rowId: number }> = ({ columns, rowId }) => (
    <>
        {_.times(columns, (key) => (
            <RenderCell delay={(key + 1) * 0.5} key={`header-${key}-${rowId}`}>
                {key}
            </RenderCell>
        ))}
    </>
)

/**
 * This component renders a loader for the grid
 * @author Alejandro Quiroz <alejandro.devop@gmail.com>
 * @version 1.0.0
 * @param param0
 * @returns
 */
const TableLoader: React.FC<{ rows: number; columns: number }> = ({ rows, columns }) => {
    return (
        <Table>
            <thead>
                <tr>
                    <RenderRow rowId={100} columns={columns} />
                    <TD className="actions">
                        <Cell />
                    </TD>
                </tr>
            </thead>
            <tbody>
                {_.times(rows, (key) => (
                    <tr key={`row-${key}`}>
                        <RenderRow rowId={key} columns={columns} />
                        <TD>
                            <ActionButtonsWrapper className="actions-button-wrapper">
                                <ActionWrapper>
                                    <ActionButton circle />
                                </ActionWrapper>
                                <ActionWrapper>
                                    <ActionButton circle />
                                </ActionWrapper>
                                <ActionWrapper>
                                    <ActionButton circle />
                                </ActionWrapper>
                            </ActionButtonsWrapper>
                        </TD>
                    </tr>
                ))}
            </tbody>
        </Table>
    )
}

export default TableLoader
